const finance = {
  state: {
    multipleSelectionId: [], // 步骤1的人员信息数组
    tableData: [], // 步骤2存的接口返回的结果集
    accountList: [] // 步骤3存的接口返回的结果集
  },
  getters: {
    multipleSelectionId: state => {
      return state.multipleSelectionId
    },
    tableData: state => {
      return state.tableData
    },
    accountList: state => {
      return state.accountList
    }
  },
  mutations: {
    SET_MULTIPLESELECTIONID (state, multipleSelectionId) {
      state.multipleSelectionId = multipleSelectionId
    },
    SET_TABLEDATA (state, tableData) {
      state.tableData = tableData
    },
    SET_ACCOUNTLIST (state, accountList) {
      state.accountList = accountList
    }
  },
  actions: {}
}

export default finance



// WEBPACK FOOTER //
// ./src/store/modules/finance.js